import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=c9e63cd8&scoped=true&"
import script from "./Recaptcha.vue?vue&type=script&lang=ts&"
export * from "./Recaptcha.vue?vue&type=script&lang=ts&"
import style0 from "./Recaptcha.vue?vue&type=style&index=0&id=c9e63cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e63cd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
